<template>
  <div class="tag-anchor" :style="styles" :id="$attrs._id">
    <div class="tag-anchor__pos" :class="`tag-anchor__pos--tail-${tailPosition}`">
      <div
        class="tag-rich"
        :class="classes"
      >
        <div class="tag-rich__inner">
          <div v-if="label" class="tag-rich__content-col" :class="{ 'dir-rtl' : rtl }">
            <div class="tag-rich__label" v-html="label[lang]"></div>
            <div class="tag-rich__description" v-html="description[lang]"></div>
          </div>
          <div class="tag-rich__image-col" v-if="asset && asset._id">
            <img class="tag-rich__image" :src="`${$store.state.assetsPath}${asset.customThumbPath ? asset.customThumbPath : asset.thumbPath}`"> 
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['pos', 'flip', 'label', 'type', 'tail-position', 'description', 'image', 'lang', 'rtl', 'asset'],

  computed: {
    classes () {
      let classes = {}
      classes[`tag-rich--tail-${this.tailPosition}`] = true
      classes['tag-rich--flip'] = this.forceFlip
      return classes
    },

    forceFlip () {
      if (this.tailPosition.includes('right-center')) {
        return true
      }

      if (this.tailPosition.includes('left-center')) {
        return false
      }

      return this.flip
    },

    styles () {
      return {
        left: `${(this.pos.x / 20)}em`,
        top: `${(this.pos.y / 20)}em`,
      }
    }
  },
}
</script>
<style lang="scss" scoped>
@import "@/styles/_variables.scss";
@import "@/styles/_mixins.scss";

.tag-anchor {
  font-size: 1em;
  position: absolute;
  pointer-events: none;
  z-index: 15;

  &__pos {
    height: 0;
    width: 0;

    &--tail-top-left:after,
    &--tail-top-center:after,
    &--tail-top-right:after {
      @include tail3($rich-tag-bg-color-solid)
    }

    &--tail-bottom-left:after,
    &--tail-bottom-center:after,
    &--tail-bottom-right:after {
      @include tail3($rich-tag-bg-color-solid)
    }

    &--tail-left-center:after {
      @include tail3($rich-tag-bg-color-solid)
    }

    &--tail-right-center:after {
      @include tail3($rich-tag-bg-color-solid)
    }

    &--tail-top-left:before,
    &--tail-top-center:before,
    &--tail-top-right:before {
      background: $rich-tag-bg-color;
      box-shadow: $tag-box-shadow;
      content: '';
      height: 8em;
      left: 0;
      position: absolute;
      top: 0;
      transform: translateX(-50%);
      width: .25em;
    }

    &--tail-bottom-left:before,
    &--tail-bottom-center:before,
    &--tail-bottom-right:before {
      background: $rich-tag-bg-color;
      bottom: 0;
      box-shadow: $tag-box-shadow;
      content: '';
      height: 8em;
      left: 0;
      position: absolute;
      transform: translateX(-50%);
      width: .25em;
    }

    &--tail-left-center:before {
      background: $rich-tag-bg-color;
      bottom: -50%;
      box-shadow: $tag-box-shadow;
      content: '';
      height: .25em;
      left: 0;
      position: absolute;
      transform: translateY(50%);
      width: 8em;
    }

    &--tail-right-center:before {
      background: $rich-tag-bg-color;
      bottom: -50%;
      box-shadow: $tag-box-shadow;
      content: '';
      height: .25em;
      right: 0;
      position: absolute;
      transform: translateY(50%);
      width: 8em;
    }
  }
}

.tag-rich {
  background-color: transparent;
  color: $rich-tag-font-color;
  cursor: grab;
  font-family: $touchscreen-font;
  font-size: $rich-tag-font-size;
  height: 14em;
  letter-spacing: .05em;
  line-height: 1.2em;
  overflow: visible;
  pointer-events: auto;
  position: absolute;
  width: 17em;
  z-index: 5;

  * {
    pointer-events: none;
    user-select: none;
  }

  &--flip {
    .tag-rich__image-col {
      transform: translateX(-197%);

      .tag-rich__image {
        clip-path: polygon(100% 0%, 98% 1.5%, 97% 4%, 97% 50%, 97% 96%, 98% 98.5%, 100% 100%, 0% 100%, 0% 50%, 0% 0%);
        height: 100%;
        transform: translateX(0);
        width: 100%;
        object-fit: cover;
        border-radius: $rich-tag-border-radius;
        border-bottom-right-radius: 0;
        border-top-right-radius: 0;
      }

      .tag-rich__video {
        clip-path: polygon(100% 0%, 98% 1.5%, 97% 4%, 97% 50%, 97% 96%, 98% 98.5%, 100% 100%, 0% 100%, 0% 50%, 0% 0%);
        height: 100%;
        transform: translateX(0);
        width: 100%;
        object-fit: cover;
        border-radius: $rich-tag-border-radius;
        border-bottom-right-radius: 0;
        border-top-right-radius: 0;
      }
    }
  }

  &--tail-top-left {
    left: -$rich-tag-font-size * 2;
    top: 8em / $rich-tag-font-size + em;
  }

  &--tail-top-center {
    left: 50%;
    top: 8em / $rich-tag-font-size + em;
    transform: translateX(-50%);
  }

  &--tail-top-right {
    right: -$rich-tag-font-size * 2;
    top: 8em / $rich-tag-font-size + em;
  }

  &--tail-bottom-left {
    left: -$rich-tag-font-size * 2;
    bottom: 8em / $rich-tag-font-size + em;
  }

  &--tail-bottom-center {
    left: 50%;
    bottom: 8em / $rich-tag-font-size + em;
    transform: translateX(-50%);
  }

  &--tail-bottom-right {
    right: -$rich-tag-font-size * 2;
    bottom: 8em / $rich-tag-font-size + em;
  }

  &--tail-left-center {
    left: 8em / $rich-tag-font-size + em;
    transform: translateY(-50%);
  }

  &--tail-right-center {
    right: 8em / $rich-tag-font-size + em;
    transform: translateY(-50%);
  }

  &__inner {
    display: flex;
    height: 14em;
    position: absolute;
    width: 34em;
  }

  &__image-col {
    border-radius: $rich-tag-border-radius;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    height: 100%;
    left: 0;
    top: 0;
    width: 50%;
    filter: drop-shadow($tag-box-shadow);
    overflow: hidden;
    pointer-events: auto;
    transform: translateX(-3%);
  }

  &__image {
    clip-path: polygon(100% 0%, 100% 50%, 100% 100%, 0% 100%, 2% 98.5%, 3% 96%, 3% 50%, 3% 4%, 2% 1.5%, 0% 0%);
    height: 100%;
    transform: translateX(0%);
    width: 100%;
    object-fit: cover;
    border-radius: $rich-tag-border-radius;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }

  &__content-col {
    background: $rich-tag-bg-color-solid;
    border-radius: $rich-tag-border-radius;
    box-shadow: $tag-box-shadow;
    height: 100%;
    overflow: hidden;
    padding: 1.5em;
    width: 50%;
    z-index: 2;
  }

  &__label {
    font-size: 1.3em;
    font-weight: 300;
    line-height: 1.1em;
    margin-bottom: .6em;
    margin-top: .1em;
    -webkit-font-smoothing: auto;
  }

  &__description {
    font-size: 0.75em;
    font-weight: 200;
    line-height: 1.4;
  }
}
</style>
